import MobileAdBanner from './mobile-ad-banner'

export default function MobileAdBannerWrapper({
  ad,
  placement,
  index,
}) {
  if (!ad) {
    return null
  }

  return (
    <div className="w-full">
      <MobileAdBanner ad={ad} placement={placement} />
    </div>
  )
}
